import { prefixObjectValues } from '../utils';

import form from './form';
import table from './table';

const top = prefixObjectValues(
  {
    uploadFileButton: 'upload-file-button',
    uploadPromptIcon: 'upload-prompt-icon',
    uploadPromptContent: 'upload-prompt-content',
    uploadPromptText: 'upload-prompt-text',
    uploadPromptAction: 'upload-prompt-action',
    layout: 'layout',
  },
  'account-documents'
);

export default {
  form,
  table,
  ...top,
};
